import { render, staticRenderFns } from "./AdditionalAnswer.vue?vue&type=template&id=d1105bd8&scoped=true&"
import script from "./AdditionalAnswer.vue?vue&type=script&lang=js&"
export * from "./AdditionalAnswer.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalAnswer.vue?vue&type=style&index=0&id=d1105bd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1105bd8",
  null
  
)

export default component.exports